module.exports = __webpack_public_path__ + "static/img/unit8.b174958.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unit8.png
// module id = RTK4
// module chunks = 1